import React from 'react';

/**
 * Component to render category/subcategory icons
 * Handles both emoji icons and image URLs
 * @param {Object} props
 * @param {string} props.icon - Icon (emoji or URL)
 * @param {number} props.size - Size in pixels (default: 20)
 * @param {Object} props.style - Additional styles
 */
const CategoryIcon = ({ icon, size = 20, style = {}, className = '' }) => {
  if (!icon) {
    return <span style={{ width: size, height: size, display: 'inline-block', ...style }} className={className}>📋</span>;
  }

  // Check if icon is a URL
  const isUrl = typeof icon === 'string' && (
    icon.startsWith('http://') || 
    icon.startsWith('https://') || 
    icon.startsWith('//')
  );

  if (isUrl) {
    return (
      <img 
        src={icon} 
        alt="" 
        style={{ 
          width: size, 
          height: size, 
          objectFit: 'contain',
          display: 'inline-block',
          verticalAlign: 'middle',
          ...style 
        }} 
        className={className}
      />
    );
  }

  // It's an emoji or symbol
  return (
    <span 
      style={{ 
        fontSize: size, 
        display: 'inline-block',
        lineHeight: 1,
        verticalAlign: 'middle',
        ...style 
      }} 
      className={className}
    >
      {icon}
    </span>
  );
};

export default CategoryIcon;
